export default __webpack_public_path__ + "static/media/tokiKitSelection@2x.d5f6e656.png";